import {typeAffirmer,validate_object,compose_object}  from "@player/src/mixins.js";
import {compose} from '@player/src/supports.js';

let rootContentInstance={
    [Symbol.hasInstance](instance){
        return instance.rootContentInstance ===this;
    }
};
let propContents={
    contentId:{
        test:typeAffirmer('string')
    },
    title:{
        default:'',
        test:typeAffirmer('string')
    },
    source:{
        default:[],
        test:typeAffirmer('array'),
        name:'_source',
        warn(val){
            if(!val.length)return 'no source available for a playlist item.';
        }
    },
    poster:{
        default:[],
        test:typeAffirmer('array'),
        name:'_poster'
    },
    position:{
        default:0,
        test:typeAffirmer('number')
    },
    subtitles:{
        default:[],
        test:typeAffirmer('array')
    },
    secondsPlayed:{
        default:0,
        test:typeAffirmer('number')
    },
    toEndSeconds:{
        default:9,
        test:typeAffirmer('number')
    },
    live:{
        default:false,
        test:typeAffirmer('boolean')
    },
    contentQuality:{
        default:720,
        test:typeAffirmer('number')
    },
    packageId:{
        default:''
    },
    drmScheme:{
        default:''
    },
    drmToken:{
        default:'',
        test:typeAffirmer('string'),
        name:'_drmToken'
    },
    providerId:{
        default:''
    },
    rootContentInstance:{
        default:rootContentInstance
    }
}


let methods={
    getSource(index=0){
        return this._source[index]??null;
    },
    getPoster(index=0){
        return this._poster[index]??null;
    }
}

let createPlayerContent=compose(compose_object(methods),validate_object(propContents))

export {createPlayerContent,rootContentInstance};